/**
 * This is not a presentational component
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FC, ReactNode } from 'react';
import { useSessionWatcherState } from './useSessionWatcherState';

export const SessionWatcher: FC<{ children: ReactNode }> = ({ children }) => {
    useSessionWatcherState();

    return (
        <>
            {/* Disabled until true logout is supported */}
            {/* <WiredSessionNearingExpiry onLogoutHook={onLogout} /> */}
            {children}
        </>
    );
};
